
import { Component, Vue } from "nuxt-property-decorator";

@Component({
  scrollToTop: true,
  components: {},
})
export default class BlogIndexPage extends Vue {
  transformMenuItems: Array<object> = [
    {
      name: "News",
      title: "News zum Thema Heizölpreise",
      link: { path: "/news" },
      externalLink: false,
    },
    {
      name: "News-Archiv",
      title: "New zur Heizölpreisentwicklung der letzten Monate und Jahre",
      link: { path: "/news/archiv" },
      externalLink: false,
    },
    {
      name: "Charts",
      title: "Heizölpreise und Ölpreise im Blick bei esyoil",
      link: { path: "/news/charts" },
      externalLink: false,
    },
  ];
}
